import React, { createContext, useState, useContext } from 'react';

interface GlobalLoadingContextType {
    globalLoading: boolean;
    setGlobalLoading: (loading: boolean) => void;
}

const GlobalLoadingContext = createContext<GlobalLoadingContextType | undefined>(undefined);

export const GlobalLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [globalLoading, setGlobalLoading] = useState(false);

    return (
        <GlobalLoadingContext.Provider value={{ globalLoading, setGlobalLoading }}>
            {children}
        </GlobalLoadingContext.Provider>
    );
};

export const useGlobalLoading = () => {
    const ctx = useContext(GlobalLoadingContext);
    if (!ctx) throw new Error('useGlobalLoading must be used within GlobalLoadingProvider');
    return ctx;
};